module.exports = __webpack_public_path__ + "static/media/Gradient_Client_Page_(optimized).d0069563.png";